'use client';

import {
  TagsList as TagsListBase,
  type TagsListProps,
} from '@shared/ui-components/tags-list/tags-list';

import { withCustomLinkComponent } from '../../i18n/with-custom-link-component';

export const TagsList = (props: Omit<TagsListProps<any>, 'LinkComponent'>) =>
  withCustomLinkComponent(TagsListBase, props);
